import Dialog from "@repo/ui/components/ui/dialog";

type InfoDialogProps = {
  open: boolean;
  onClose: () => void;
  title: string;
  description?: string;
  actions?: React.ReactNode;
};

export default function InfoDialog({
  open,
  onClose,
  title,
  description,
  actions,
}: InfoDialogProps) {
  return (
    <Dialog open={open} setOpen={onClose}>
      <div>
        <p className="text-2xl font-bold text-secondary-black">{title}</p>
        <p className="text-xl text-secondary-black pt-5">{description}</p>
        <div className="flex justify-end gap-2 mt-8">{actions}</div>
      </div>
    </Dialog>
  );
}
